import s from './ErrorMsg.module.css'

type Props = {
  text: string
  matter?: boolean
}

export const ErrorMsg = ({ text, matter = true }: Props) => {
  return (
    <small className={`${s.error} ${matter ? s.matter : ''}`}>{text}</small>
  )
}
